import { useEffect, useRef, useCallback, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
console.log(API,"==================>234");

function getSessionId() {
  let sid = sessionStorage.getItem('analytics_sid');
  if (!sid) {
    sid = 'ses_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem('analytics_sid', sid);
  }
  return sid;
}

function getDeviceInfo() {
  const ua = navigator.userAgent;
  const isMobile = /Mobi|Android|iPhone|iPad/i.test(ua);
  const isTablet = /iPad|Android(?!.*Mobile)/i.test(ua);
  let browser = 'Other';
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) browser = 'Chrome';
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = 'Safari';
  else if (/Firefox/i.test(ua)) browser = 'Firefox';
  else if (/Edg/i.test(ua)) browser = 'Edge';

  let os = 'Other';
  if (/Windows/i.test(ua)) os = 'Windows';
  else if (/Mac/i.test(ua)) os = 'macOS';
  else if (/Linux/i.test(ua)) os = 'Linux';
  else if (/Android/i.test(ua)) os = 'Android';
  else if (/iPhone|iPad/i.test(ua)) os = 'iOS';

  return {
    type: isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop',
    browser,
    os,
    language: navigator.language,
  };
}

async function fetchLocation() {
  try {
    const r = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) });
    if (!r.ok) return {};
    const d = await r.json();
    return { city: d.city, region: d.region, country: d.country_name, country_code: d.country_code, latitude: d.latitude, longitude: d.longitude };
  } catch {
    return {};
  }
}

export function useAnalytics(user) {
  const location = useLocation();
  const sessionStarted = useRef(false);
  const sid = useRef(getSessionId());

  const hasConsent = () => localStorage.getItem('cookieConsent') === 'accepted';

  const trackEvent = useCallback((eventType, feature, page, metadata = {}) => {
    if (!hasConsent()) return;
    axios.post(`${API}/analytics/event`, {
      session_id: sid.current,
      event_type: eventType,
      page: page || window.location.pathname,
      feature,
      metadata,
    }, { withCredentials: true }).catch(() => {});
  }, []);

  // Start session once
  useEffect(() => {
    if (sessionStarted.current || !hasConsent()) return;
    sessionStarted.current = true;

    (async () => {
      const loc = await fetchLocation();
      await axios.post(`${API}/analytics/session`, {
        session_id: sid.current,
        device: getDeviceInfo(),
        location: loc,
        referrer: document.referrer || null,
        screen_resolution: `${window.screen.width}x${window.screen.height}`,
      }, { withCredentials: true }).catch(() => {});
    })();
  }, []);

  // Track page views on route change
  useEffect(() => {
    if (!hasConsent()) return;
    trackEvent('page_view', null, location.pathname);
  }, [location.pathname, trackEvent]);

  // Heartbeat every 60s
  useEffect(() => {
    if (!hasConsent()) return;
    const iv = setInterval(() => {
      axios.post(`${API}/analytics/heartbeat`, { session_id: sid.current }, { withCredentials: true }).catch(() => {});
    }, 60000);
    return () => clearInterval(iv);
  }, []);

  return { trackEvent };
}
